(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bjp-video-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bjp-video-hero')) {
  customElements.define('bjp-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const video = this.querySelector('video');
      const poster = this.querySelector('.bjp-hero-poster');
      const toggle = this.querySelector('.bjp-hero-toggle');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const mobile = window.matchMedia('(max-width: 767px)');
      let pausedByUser = false;
      const updateControl = () => {
        toggle.dataset.paused = String(video.paused);
        toggle.setAttribute('aria-label', video.paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
      };
      const play = () => video.play().catch(updateControl);
      const start = () => {
        if (!this.isConnected) return;
        if (reducedMotion.matches) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          this.classList.remove('has-frame');
          toggle.hidden = true;
          return;
        }
        if (poster && !poster.complete) return;
        const source = mobile.matches && this.dataset.mobileSrc ? this.dataset.mobileSrc : this.dataset.desktopSrc;
        if (!source) return;
        if (video.getAttribute('src') !== source) {
          this.classList.remove('has-frame');
          if (poster) video.poster = poster.currentSrc || poster.src;
          video.muted = true;
          video.autoplay = !pausedByUser;
          video.src = source;
          video.load();
        }
        toggle.hidden = false;
        updateControl();
        if (!pausedByUser) play();
      };
      toggle.addEventListener('click', () => {
        pausedByUser = !video.paused;
        if (pausedByUser) video.pause();
        else play();
      }, options);
      video.addEventListener('playing', () => { this.classList.add('has-frame'); updateControl(); }, options);
      video.addEventListener('pause', updateControl, options);
      video.addEventListener('error', () => { this.classList.remove('has-frame'); toggle.hidden = true; }, options);
      reducedMotion.addEventListener('change', start, options);
      mobile.addEventListener('change', start, options);
      if (poster) poster.addEventListener('load', () => requestAnimationFrame(start), options);
      requestAnimationFrame(() => requestAnimationFrame(start));
    }
    disconnectedCallback() {
      this.events.abort();
      this.querySelector('video').pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
